"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _Link = _interopRequireDefault(require("Link"));

var _scss = require("@scss");

var _excluded = ["component", "variant", "type", "block", "events", "onClick", "onFocus", "href", "target", "tabIndex", "disabled", "className", "beforeContent", "afterContent", "children", "download"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = /*#__PURE__*/(0, _react.forwardRef)(function Button(_ref, ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'a' : _ref$component,
      variant = _ref.variant,
      type = _ref.type,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? false : _ref$block,
      _ref$events = _ref.events,
      events = _ref$events === void 0 ? {} : _ref$events,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '#' : _ref$href,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? '_self' : _ref$target,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? null : _ref$tabIndex,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      className = _ref.className,
      beforeContent = _ref.beforeContent,
      afterContent = _ref.afterContent,
      children = _ref.children,
      download = _ref.download,
      props = _objectWithoutProperties(_ref, _excluded);

  var Tag = component === 'a' ? _Link["default"] : component;
  return /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    className: (0, _scss.cls)(_stylesModule["default"]['btn'], variant && _stylesModule["default"]["btn-".concat(variant)], block && _stylesModule["default"]['btn-block'], className),
    ref: ref
  }, onClick && {
    onClick: onClick
  }, onFocus && {
    onFocus: onFocus
  }, component !== 'button' && {
    href: href,
    target: target
  }, download && {
    download: true
  }, component === 'button' && type && {
    type: type
  }, tabIndex !== null && {
    tabIndex: tabIndex
  }, disabled && {
    disabled: true
  }, events, props), beforeContent, typeof children === 'string' ? /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: children
    }
  }) : children, afterContent);
});
var _default = Button;
exports["default"] = _default;